import Header from './Header'
import Footer from './Footer'

function AccidentesTransito() {
    const title = 'Accidentes de tránsito'
    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/accidentes-transito.png" className="img-fluid" alt="accidentes de tránsito" style={{'padding': '5%'}} />
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="fst-italic justified-text">
                          ¿Sufriste un accidente de tránsito y la aseguradora te ofrece menos de lo que te corresponde? <strong>No firmes nada sin asesorarte primero.</strong>
                        </p>
                        <p className="justified-text">En <strong>MFV ABOGADOS</strong> nos encargamos de reclamar tu indemnización frente a la compañía de seguros del responsable, ya sea por vía extrajudicial o judicial. Contamos con <strong>médico legista propio</strong> para evaluar tus lesiones y fundamentar el reclamo con la mayor incapacidad posible. Nuestro objetivo es que recibas una compensación justa por todos los daños sufridos — físicos, psicológicos y materiales — sin que tengas que preocuparte por el proceso.</p>

                        <h4>¿Qué hacemos por vos?</h4>
                        <ul>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo a la aseguradora del tercero</strong> — gestionamos tu indemnización ante la compañía de seguros del responsable del accidente.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo judicial por daños y perjuicios</strong> — si la aseguradora no responde o la oferta es insuficiente, vamos a juicio para obtener lo que realmente te corresponde.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño físico</strong> — reclamamos por lesiones corporales e incapacidad con respaldo de nuestro médico legista.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño psicológico</strong> — incluimos el componente psíquico que las aseguradoras siempre intentan minimizar.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño material</strong> — reparación del vehículo, destrucción total, privación de uso y desvalorización.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Lucro cesante</strong> — si el accidente te impidió trabajar, reclamamos la pérdida de ingresos.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Accidentes como peatón o ciclista</strong> — también te representamos si fuiste atropellado o embestido sin estar al volante.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño moral</strong> — reclamamos por el sufrimiento, la angustia y la alteración de tu vida cotidiana.</li>
                        </ul>

                        <p className="justified-text"><strong>No aceptes la primera oferta de la aseguradora.</strong> Las compañías buscan cerrar rápido y por menos de lo que realmente corresponde. Dejá que te asesoremos antes de firmar cualquier acuerdo.</p>
                        <p className="justified-text">Por consultas o inquietudes podés escribirnos al <a className='black-link' href="https://wa.me/+5491124089830?text=Hola%2C%20tuve%20un%20accidente%20de%20tr%C3%A1nsito%20y%20necesito%20asesoramiento">11-2408-9830.</a></p>
                        <br/>
                        <a href="https://wa.me/+5491124089830?text=Hola%2C%20tuve%20un%20accidente%20de%20tr%C3%A1nsito%20y%20necesito%20asesoramiento" className="cta-button">Hablemos de tu caso</a>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>
        </>
    );
}

export default AccidentesTransito;
